<template>
  <div class="book-meeting-alert" data-testid="bam-alert">
    <VMessage v-if="requestSettings.status === 'none-available'" class="items-center" :show="true" banner-type="warning" theme="settings"
      >All admins have disabled this feature. To turn it on, please enable your calendar
      <template #dismiss>
        <VButton class="inline-block w-full text-center" size="sm" no-shadow="noShadow" no-border="noBorder" @click="enableSettings">
          Turn on calendar
        </VButton>
      </template>
    </VMessage>

    <VMessage v-if="requestSettings.status === 'inactive'" class="items-center" :show="true" theme="settings" banner-type="warning"
      >Looks like your calendar is disabled. To turn it on, please enable your calendar
      <template #dismiss>
        <VButton class="inline-block w-full text-center" size="sm" no-shadow="noShadow" no-border="noBorder" @click="enableSettings">
          Turn on calendar
        </VButton>
      </template>
    </VMessage>

    <VMessage
      v-if="requestSettings.status === 'incomplete' || requestSettings.status === 'not-setup'"
      class="items-center"
      :show="true"
      banner-type="warning"
      theme="settings"
      >Looks like you haven't set up your calendar. To use your availability, please set up your calendar
      <template #dismiss>
        <VButton
          class="inline-block w-full text-center"
          size="sm"
          no-shadow="noShadow"
          no-border="noBorder"
          @click="$emit('set-up-calendar')"
          >Set up calendar</VButton
        >
      </template>
    </VMessage>

    <div class="w-96">
      <VMessage
        v-show="shouldDisplayBAMToast"
        class="items-center"
        :show="true"
        banner-type="success"
        theme="settings"
        hide-dismiss
        data-testid="bam-success"
        >Your calendar is enabled
        <template #dismiss>&nbsp;</template>
      </VMessage>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { PropType, DeepReadonly } from 'vue'
import { toRefs } from 'vue'

import type { BookMeetingStatus } from '~/composables/useBookMeeting'

const props = defineProps({
  requestSettings: {
    type: Object as PropType<DeepReadonly<BookMeetingStatus>>,
    required: true,
  },
  shouldDisplayBAMToast: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['activate-book-a-meeting', 'sync-calendar', 'set-up-calendar'])

const { requestSettings } = toRefs(props)

function enableSettings() {
  if (requestSettings.value.status === 'none-available' || requestSettings.value.status === 'inactive') {
    if (requestSettings.value.currentUser.number_of_calendars) {
      // Three state possibility:
      // - User has/has not ever set up BAM
      // - User has set up BAM, but their calendar is not synced
      // - User has set up BAM, but disabled it using our toggle

      // User has set up BAM and connected a calendar, we just need to update the API
      emit('activate-book-a-meeting', requestSettings.value.currentUser)
    } else {
      // User has no connected calendars and must go through an OAuth process
      emit('sync-calendar')
    }
  }
}
</script>
